<template>
  <div v-if="history.data.data.length" class="payment-account-history">
    <h4 class="payment-account-history__title">
      <BaseSvg name="ico-archive"/>
      <span>{{$tPayment('Payment archive')}}:</span>
    </h4>

    <template>
      <div  v-for="item in history.data.data" :key="item" class="payment-account-history__item">
        <time class="payment-account-history__item-time">
          {{ item.created_at }}
        </time>
        <div class="payment-account-history__item-value">
          {{ item.transactionAmount }} {{ item.transactionCurrencyCode }}
        </div>
        <div class="payment-account-history__item-direction">
          {{ item.paymentState }}
        </div>
      </div>
    </template>

    <button v-if="this.history.data.next_page_url" @click="nextPage" class="payment-account-history__more-btn base-btn  base-btn--outline-dark">
      {{$tPayment('Download more')}}
    </button>

  </div>
</template>

<script>
  import {http} from '@/axios'

  export default {
    name: 'PaymentAccountHistory',
    props:{
      history: [Array, Object],
    },
    data() {
      return {

      }
    },
    methods: {
      nextPage() {
        //console.log('nextPage');
        http.get(this.history.data.next_page_url)
                .then(({data}) => {
                  if(data.status===1) {
                    data.data.data.forEach(o => {
                      this.history.data.data.push(o)
                    })
                    this.history.data.next_page_url = data.data.next_page_url;
                  }
                })
      }
    },
    created() {
      //this.update()
    }
  }
</script>

<style lang="less">

</style>
